<main>
  <out-location-page-title
    [location]="location"
    [currentRoute]="currentRoute"
  ></out-location-page-title>
  <section class="py-5 lg:py-10 px-3 xl:px-52">
    <div class="container mx-auto">
      <div
        *ngIf="listings.length > 0 && !loading"
        class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-7 xl:gap-y-10"
      >
        <div *ngFor="let listing of listings">
          <out-listing-card [listing]="listing"></out-listing-card>
        </div>
      </div>

      <div *ngIf="listings.length === 0 && !loading" class="text-center py-32 lg:py-42 text-gray-500">
        <img
          src="/assets/images/no-data.png"
          class="mx-auto size-28 2xl:size-42"
          alt="No data image"
        />
        <h4 class="text-lg 2xl:text-xl font-medium ">
          No listings found for the selected location.
        </h4>
        <a
          routerLink="/locations"
          class="rounded-full bg-OUT-Blue font-semibold hover:bg-OUT-Blue/90 transition-colors duration-300 px-6 py-2 text-white mt-3 inline-block cursor-pointer"
          >Go Back</a
        >
      </div>

      <div
        *ngIf="loading"
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 xl:gap-x-7 xl:gap-y-10"
      >
        <div *ngFor="let placeholderSkeleton of placeholderSkeletons">
          <out-listing-skeleton></out-listing-skeleton>
        </div>
      </div>
    </div>
  </section>
</main>
